module.exports = __webpack_public_path__ + "ao.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ao.svg
// module id = 418
// module chunks = 0